import { DefaultTheme } from 'styled-components';
export const darkTheme: DefaultTheme = {
  type: 'dark',
  // default space for margin and padding
  // default space for margin and padding
  space: (n: number): number => n * 4,
  fontSize: [12, 14, 16, 20, 24, 28, 32],
  borderRadius: '16px',
  borderInputRadius: '8px',
  boxShadow: '0px 3px 7px rgba(33, 33, 33, 0.1)',
  palette: {
    neutral: {
      neutral100: '#FFFFFF', //mk1
      neutral75: '#AAAFB4', //mk2
      neutral45: '#6C6F72',
      neutral30: '#414141', //contour
      neutral15: '#414141', //beam
      base: '#282828', //base
      surface2: '#202020', //compartment
      surface: '#141414',
    },
    primary: {
      primary700: '#ECE0F9', // dark
      primary600: '#CDB4E6', //main
      primary500: '#918CED', // light
      primary300: '#5050B2',
      primary200: '#433EA3',
      primary50: '#39234F', //ultraLight
    },
    secondary: {
      red300: '#FF8968', //main , light, dark
    },
    tertiary: {
      yellow300: '#FAF277', //main , light, dark
    },
    quaternary: {
      blue300: '#4CC5F5', //main , light, dark
    },
    system: {
      verified: {
        main: '#B8EBA5', // dark
        light: '#DFF6D7',
      },
      alert: {
        main: '#FFC1B0', // dark
        red50: '#2C2422', // ultraLight
      },
      query: {
        main: '#FFFBBD', // dark
        yellow50: '#2B2B26',
      },
      info: {
        main: '#84DBFF',
        blue50: '#272429',
      },
    },
  },
};
